export interface Comment {
    id: number;
    commentHandleId?: number;
    parentId?: number | null;
    accountId: number;
    authorEmail: string;
    authorName: string;
    message: string;
    created: Date;
    edited: Date | null;
    isResolved: boolean;
    isDeleted: boolean;
    $expanded: boolean;
    newReaction?: string;
    own: boolean;
    reactions?: any;
    pendingReaction?: any;
    comments: Comment[];
}
